export const ASSETS = {
  logo: 'https://customer-assets.emergentagent.com/job_608deb45-78fd-4ff6-84b4-4a0796a0937c/artifacts/gjr3j0fk_Nurture%20the%20self%20logo.jpeg',
  // Verified warm Pexels imagery
  heroMeadow:    'https://images.pexels.com/photos/1166209/pexels-photo-1166209.jpeg',   // lavender sunset path
  goldField:     'https://images.pexels.com/photos/35962839/pexels-photo-35962839.jpeg', // golden meadow field
  sunThroughTrees: 'https://images.pexels.com/photos/31298973/pexels-photo-31298973.jpeg', // soft sun through trees
  // User-provided brand assets
  joinUsPoster:  'https://customer-assets.emergentagent.com/job_608deb45-78fd-4ff6-84b4-4a0796a0937c/artifacts/k3pkxr8w_Nurture%20the%20self%20join%20us.jpeg',
  aboutVisual:   'https://customer-assets.emergentagent.com/job_608deb45-78fd-4ff6-84b4-4a0796a0937c/artifacts/co7cvtu0_Nutrue%20the%20self.jpeg',
  course1:       'https://customer-assets.emergentagent.com/job_608deb45-78fd-4ff6-84b4-4a0796a0937c/artifacts/0raf34bi_Nurture%20the%20self%20course%201.jpeg',
  facilitatorCharlotte:  'https://customer-assets.emergentagent.com/job_wellness-compass-48/artifacts/q9rx3bsm_20260130_205433.jpg',
  facilitatorJaquelynn:  'https://customer-assets.emergentagent.com/job_wellness-compass-48/artifacts/r3tjlbvw_Jaquelynn%20A%20Margiotta.jpeg',
};

export const BRAND = {
  name: 'Nurture the Self',
  tagline: 'a therapeutic pathway',
  strapline: 'Nourish. Reconnect. Become.',
  centralMessage:
    'Healing relationship with food begins with nurturing relationship with self.',
  intro:
    'Nurture the Self is a carefully held therapeutic pathway supporting individuals towards a healthier relationship with food, body and self through psychotherapy, embodiment and anthroposophically informed practice.',
};

export const CLOSING_STATEMENT = {
  body:
    'Healing is rarely about becoming someone different. More often, it is a gradual return to the person you have always been beneath the adaptations that once helped you survive. Through nourishment, relationship, rhythm and compassionate understanding, we hope to accompany you on that journey.',
  strapline: 'Nourish. Reconnect. Become.',
};

export const PATH_SUMMARIES = [
  {
    id: 'path-1',
    label: 'Path I',
    title: 'Returning to Nourishment, Rhythm & Self',
    stage: 'Nourish',
    summary: 'Learning to nourish yourself beyond food and cultivate rhythm, vitality and self-trust.',
  },
  {
    id: 'path-2',
    label: 'Path II',
    title: 'Reconnecting with Body, Self & World',
    stage: 'Reconnect',
    summary: 'Exploring the wisdom of the Twelve Senses to deepen embodied awareness, strengthen relationships and reconnect with the world around us.',
  },
  {
    id: 'path-3',
    label: 'Path III',
    title: 'Integration, Identity & Becoming',
    stage: 'Become',
    summary: 'Exploring biography alongside the Threefold and Fourfold understanding of the human being to integrate experience and cultivate a deeper sense of purpose, authenticity and wholeness.',
  },
];

export const PATHS = [
  {
    id: 'path-1',
    label: 'Path I',
    title: 'Returning to Nourishment, Rhythm & Self',
    framework: 'The Twelve Life Processes',
    core_question: 'How do I nourish and sustain life within myself?',
    themes: ['nourishment', 'receiving', 'self-trust', 'rhythm', 'vitality', 'growth', 'transformation'],
    description:
      'A gentle beginning. We slow down, listen inward, and begin to remember what it feels like to be nourished — in body, breath and being. Together we explore the rhythms that sustain life within us, and how compassionate attention can become the ground for healing.',
    starts: 'September 15, 2026',
    time: '6:30 – 8:30 pm (GMT)',
    duration: '12 weeks · Held online',
  },
  {
    id: 'path-2',
    label: 'Path II',
    title: 'Reconnecting with Body, Self & World',
    framework: 'The Twelve Senses',
    core_question: 'How do I experience myself, others and the world more fully?',
    themes: ['embodiment', 'boundaries', 'sensory awareness', 'communication', 'belonging', 'connection', 'presence'],
    description:
      'A deepening. We turn toward the body as a wise companion and explore the many ways we sense ourselves, others and the world. With care, we begin to repair the bridges between inner experience and the world — meeting life with more honesty, tenderness and presence.',
    starts: 'Spring 2027',
    time: '6:30 – 8:30 pm (GMT)',
    duration: '12 weeks · Held online',
  },
  {
    id: 'path-3',
    label: 'Path III',
    title: 'Integration, Identity & Becoming',
    framework: 'Biography · The Threefold & Fourfold Human Being',
    core_question: 'Who am I, and who am I becoming?',
    themes: ['life story', 'identity', 'meaning', 'purpose', 'patterns', 'individuality', 'integration'],
    description:
      'A weaving. We gather the threads of our story — what has been remembered, healed and discovered — and let them shape the life that is unfolding. This is not an ending but a quiet inauguration: of a self that is more whole, more known, more at home.',
    starts: 'Autumn 2027',
    time: '6:30 – 8:30 pm (GMT)',
    duration: '12 weeks · Held online',
  },
];

export const WEEKLY_SHAPE = [
  { week: 'Weeks 1 – 3', title: 'Arriving & Listening', body: 'Settling into the group, the rhythm of the work, and a softer way of attending to the self. Foundational practices for nervous-system safety.' },
  { week: 'Weeks 4 – 6', title: 'Nourishment & Receiving', body: 'Exploring what it means to be nourished — physically, emotionally, spiritually — and our capacity to receive. Compassion for old patterns.' },
  { week: 'Mid-point', title: 'Integration Week', body: 'A protected pause after session 6 — a week without a session, held with reflective resources, to let what has been touched settle into the body.' },
  { week: 'Weeks 7 – 9', title: 'Embodiment & Rhythm', body: 'Returning to the body as ally rather than adversary. Working with breath, movement and daily rhythm as healing supports.' },
  { week: 'Weeks 10 – 12', title: 'Self-Trust & Becoming', body: 'Cultivating trust in our own inner authority. Closing rituals, integration practices and a gentle look at what is next.' },
];

export const PROGRAMME_STRUCTURE = [
  { title: '12 weekly live online sessions', body: 'Two-hour sessions, held at the same time each week to support rhythm and continuity.' },
  { title: 'Mid-point integration week', body: 'A protected pause after session 6 — space for what has begun to land.' },
  { title: 'A small therapeutic group', body: 'Carefully composed, intentionally held. Group size is kept small so each person can be met.' },
  { title: 'Dual facilitation', body: 'Two practitioners hold each path, bringing complementary lenses to the work.' },
  { title: 'Reflective exercises & workbook', body: 'Gentle practices for between sessions — to be picked up and put down as feels right.' },
  { title: '4-week integration period', body: 'Following the 12 weeks, a quiet integration window with weekly emails and a Zoom integration circle, gently preparing for the next path.' },
];

export const THERAPEUTIC_PRINCIPLES = [
  'Symptoms are meaningful.',
  'Healing happens in relationship.',
  'Nourishment extends far beyond food.',
  'Recovery is non-linear.',
  'Rhythm supports regulation.',
  'Embodiment supports healing.',
  'Self-compassion is fundamental.',
  'Every person has innate capacities for growth, vitality and transformation.',
];

export const WHO_FOR = [
  'diagnosed eating disorders',
  'disordered eating',
  'emotional eating',
  'chronic dieting',
  'body image difficulties',
  'perfectionism',
  'highly self-critical tendencies',
  'difficulties receiving nourishment',
  'feeling disconnected from themselves',
  'a desire for a deeper relationship with food, body and self',
];

export const APPROACHES = [
  'psychotherapy',
  'anthroposophy',
  'embodied awareness',
  'biography work',
  'creative reflection',
  'compassionate group process',
  'nature-inspired wisdom',
];

export const RETREAT = {
  title: 'An Introduction to Nurture the Self',
  dates: 'April 2027',
  venue: 'Tobias Centre · Forest Row, UK',
  duration: '4 days',
  description:
    'A four-day in-person retreat held in the gentle countryside of Forest Row. Drawing themes from all three Paths — with a particular focus on Path I — this retreat offers an opportunity to encounter the work first-hand, in community, in nature.',
  audience:
    'Open to anyone considering Nurture the Self, as well as professionals (therapists, doctors, counsellors, educators) wishing to understand more about healing the relationship with body, food and self.',
  includes: [
    'Daily therapeutic group sessions',
    'Mindful, nourishing shared meals',
    'Embodiment, walking and reflective practices',
    'Quiet time in nature and unhurried personal space',
    'A small, intentionally held group',
  ],
};

export const FUTURE_RETREATS = [
  { theme: 'The Twelve Life Processes', body: 'A seven-day immersion into the life processes that sustain us — nourishment, rhythm, vitality, growth.' },
  { theme: 'The Twelve Senses', body: 'A seven-day retreat exploring the many ways we perceive ourselves, others and the world — and how the senses guide us back to embodiment.' },
  { theme: 'The Threefold & Fourfold Human Being', body: 'A seven-day biography retreat — listening to the story of our becoming and the deeper architecture of being human.' },
];

export const INVESTMENT = {
  founding_cohort: {
    label: 'Founding Cohort Investment',
    subtitle: 'Path I — Returning to Nourishment, Rhythm & Self',
    price: '£1,500',
    intro:
      'As we launch the inaugural year of Nurture the Self, we are delighted to offer a reduced Founding Cohort investment.',
    body:
      'Participants joining this first cohort will experience the complete therapeutic programme while helping shape the future development of Nurture the Self through their reflections and feedback.',
    future_note: 'Future cohorts are expected to be offered at a higher investment.',
    payment_options: [
      'One payment of £1,500',
      'Three monthly instalments of £500',
    ],
    payment_note: 'There is no additional charge for paying by instalments.',
  },
  includes: [
    '12 weekly live online therapeutic sessions',
    '2-hour professionally facilitated sessions',
    'Dual facilitation throughout',
    'Small therapeutic group (maximum 12 participants)',
    'Complimentary intake conversation',
    'Reflective workbook',
    'Therapeutic exercises',
    'Mid-course integration week',
    'Four-week supported integration period',
    'Weekly integration reflection emails',
    'Live online integration circle',
    'Preparation for Path II',
    'Continued connection with the Nurture the Self community',
  ],
  small_groups: {
    heading: 'Intentionally Small Groups',
    body:
      'Each cohort is intentionally limited to between 8 and 12 participants. This allows every participant to be genuinely known, supported and able to participate fully within a carefully held therapeutic environment. Small groups create the conditions for trust, safety, meaningful connection and deeper therapeutic work.',
    clinical:
      'This is an intentional clinical decision rather than a practical limitation.',
  },
  investing_in_yourself: {
    heading: 'Investing in Yourself',
    intro:
      'Nurture the Self is far more than an online course. It is a carefully held therapeutic experience — an invitation to be met, understood and accompanied over the course of a year.',
    items: [
      '24 hours of live therapeutic work',
      'Two experienced facilitators',
      'Medical and psychotherapeutic expertise',
      'Anthroposophically informed therapeutic understanding',
      'Embodied practices',
      'Reflective workbook',
      'Integration support',
      'Ongoing community',
    ],
    intention:
      'Our intention is to offer a transformational therapeutic experience rather than simply educational content.',
  },
  accessibility: {
    heading: 'Accessibility',
    body: [
      'We recognise that financial circumstances vary.',
      'Flexible monthly payment plans are available.',
      'A very small number of confidential supported places may be offered each cohort following discussion during the complimentary intake conversation.',
      'Our intention is to balance accessibility with the long-term sustainability of the programme.',
    ],
  },
};

export const COMMUNITY = {
  name: 'The Nurture the Self Community',
  intro:
    'A quiet, considered correspondence — offered to those who wish to walk gently alongside our work.',
  receives: [
    'Monthly Journal',
    'Seasonal reflections',
    'Poetry',
    'Therapeutic insights',
    'Journal prompts',
    'Embodiment practices',
    'Future workshops',
    'Retreats',
    'Programme announcements',
  ],
};


export const SHARED_VISION = {
  title: 'Our Shared Vision',
  paragraphs: [
    'We first met whilst training together on the Master\u2019s programme in Anthroposophical Psychotherapy and quickly recognised a shared philosophy of care, rooted in compassion, curiosity and a whole-person understanding of health and healing.',
    'Through both our professional and personal experiences, we have repeatedly encountered a common thread: many people — particularly women, though certainly not exclusively — describe having experienced periods in their lives where their relationship with food, their bodies or themselves has become difficult, confusing or painful. Many also describe feeling that they lacked adequate support, understanding or spaces in which to safely explore these experiences.',
    'Over time, we have come to recognise that these difficulties are rarely about food alone. They often sit within broader experiences of stress, perfectionism, life transitions, self-worth, emotional overwhelm, relationships, identity and our capacity to nourish ourselves physically, emotionally and spiritually.',
    'It was from this shared understanding that *Nurture the Self* was born.',
    'Together, we have created a therapeutic pathway that seeks to move beyond symptom management and instead gently support individuals to cultivate a healthier, more compassionate and sustainable relationship with food, body and self.',
    'Our work is grounded in the belief that recovery is not simply about changing behaviours; it is about gradually rebuilding trust in oneself, reconnecting with one\u2019s innate capacities for nourishment and vitality, and discovering new ways of relating to life itself.',
    'We work collaboratively, bringing together our complementary skills, perspectives and experiences to create a safe, nurturing and thoughtfully held therapeutic space. We believe healing happens in relationship, and we are passionate about creating environments in which people feel seen, understood and supported to move beyond survival and towards a deeper sense of belonging, authenticity and wellbeing.',
    'At its heart, *Nurture the Self* is an invitation to slow down, reconnect and remember that nourishment extends far beyond food alone.',
  ],
  closing: 'Nourish. Reconnect. Become.',
};

export const FACILITATORS = [
  {
    name: 'Dr Charlotte Bamber',
    photo: ASSETS.facilitatorCharlotte,
    role: 'Medical Doctor · Psychotherapist · Founder of Whole Health',
    bio: [
      'Dr Charlotte Bamber is a Medical Doctor, Psychotherapist and founder of Whole Health. With a background in NHS Psychiatry and General Practice, she now works in private practice, supporting individuals towards greater health and wellbeing through a whole-person, integrative approach.',
      'Alongside her professional training, Charlotte brings lived experience of eating disorder recovery, offering a compassionate, empathic and nuanced understanding of the many ways our relationship with food, body and self can become shaped over time.',
      'Her work is grounded in the belief that eating disorders and difficulties with food are rarely just about food itself. Rather, they are often deeply interconnected with our life experiences, relationships, patterns of coping, sense of identity, and capacity to nourish ourselves physically, emotionally and spiritually.',
      'Charlotte creates calm, nurturing and thoughtfully held spaces where individuals can safely explore these deeper layers with curiosity and self-compassion. She supports people to move beyond symptom management alone and towards a more meaningful understanding of themselves — helping them cultivate healthier relationships with their bodies, emotions, life stories and inner worlds.',
      'Drawing upon psychotherapy, anthroposophical understanding, embodiment practices and biography work, she encourages individuals to reconnect with their innate capacities for nourishment, rhythm, vitality and self-trust.',
      'At the heart of her work is the belief that recovery is not simply the absence of an eating disorder, but a gradual process of returning to oneself — an invitation to rediscover authenticity, develop a compassionate relationship with one\u2019s whole being, and cultivate a life that feels more connected, purposeful and aligned with one\u2019s deepest values.',
      'Through Nurture the Self, Charlotte brings together her medical, psychotherapeutic and lived experience to offer a unique year-long therapeutic pathway supporting individuals to heal their relationship with food, body and self.',
    ],
  },
  {
    name: 'Jaquelynn A. Taipe',
    photo: ASSETS.facilitatorJaquelynn,
    role: 'Integrative Counsellor · Anthroposophical Art Therapist · Systemic Family Practitioner · Biographical & Interventional Family Therapist',
    bio: [
      'Jaquelynn A. Taipe is an integrative counsellor and systemic family practitioner whose work invites people to meet their own lives with greater understanding, dignity and compassion.',
      'She has spent many years accompanying individuals and families through threshold moments — supporting them to listen to the deeper movements of their lives and to recognise the meaning that has been quietly weaving itself within them.',
      'Jaquelynn\u2019s practice is rooted in a multicultural awareness shaped by her fluency in three languages — Spanish, Italian and English — and her lived understanding of three distinct cultural worlds. This openness allows her to hold space for the many ways culture, language and heritage shape our sense of self, belonging and the stories we carry within our bodies.',
      'She is currently completing a Master\u2019s in Anthroposophical Psychotherapy in Sussex, continuing to deepen her understanding of the human being as a whole — integrating body, soul and spirit within her therapeutic approach.',
      'Her work is grounded in the belief that our relationship with food, body and self is never formed in isolation. It is deeply interwoven with our families, our formative experiences, the relational patterns we inherit, and the wider cultural and social contexts we move through. She understands that healing requires us to gently return to these threads — not to untangle them, but to re-meet and re-weave them with care, curiosity and compassion.',
      'Drawing upon integrative counselling, anthroposophical art therapy, systemic family practice and biographical approaches, Jaquelynn creates warm, thoughtfully held spaces where individuals and families can explore the relational and biographical roots of their struggles. She supports people to recognise how the ways they have learned to cope, to protect themselves, and to navigate the world have been shaped over time — and how, with gentle attention, new patterns can emerge.',
      'Within Nurture the Self, Jaquelynn brings a particular sensitivity to the biographical and relational threads of recovery. She helps individuals explore how their families, formative experiences and the wider world have shaped the way they come to live within their bodies — and how, through compassionate inquiry and creative expression, those threads can be honoured, understood and gradually transformed.',
      'At the heart of her work is the belief that recovery is a deeply relational process — one that invites us to return not only to ourselves, but to the web of relationships, stories and cultural contexts that have shaped us. Through this return, we can begin to reclaim our sense of agency, authenticity and belonging, and to cultivate a life that feels more connected, purposeful and aligned with who we truly are.',
    ],
  },
];
